<div class="dialog-container">
  <div class="top-elements">
    <div class="credits" *ngIf="data.price">
      <div class="ling-credits-logo"></div>
      <span class="price-info">{{
        (data.price.explicit ? "1 " : "") +
          data.price.for +
          " = " +
          data.price.amount +
          " " +
          (handlePluralTranslation(data.price.amount, "creditName") | translate)
      }}</span>
    </div>
    <div class="dialog-close-btn-container" *ngIf="!data.disableClose">
      <button
        class="dialog-close-btn"
        [mat-dialog-close]="false"
        type="button"
      ></button>
    </div>
  </div>
  <h2 class="dialog-title" *ngIf="data.title">{{ data.title }}</h2>
  <div class="dialog-text-container">
    <p class="dialog-text" *ngIf="data.text">{{ data.text }}</p>
  </div>
  <div class="dialog-content" *ngIf="data.component">
    <ng-container *ngIf="data.component">
      <div *ngComponentOutlet="data.component"></div>
    </ng-container>
  </div>
  <mat-dialog-actions
    class="dialog-actions"
    align="center"
    *ngIf="data.confirmButtonText || data.rejectButtonText"
  >
    <button
      class="dialog-action-button"
      *ngIf="data.rejectButtonText"
      mat-flat-button
      [mat-dialog-close]="false"
      type="button"
      color="{{ data.rejectButtonType === 'confirm' ? 'primary' : 'warn' }}"
    >
      {{ data.rejectButtonText }}
    </button>
    <button
      class="dialog-action-button"
      *ngIf="data.confirmButtonText"
      mat-flat-button
      [mat-dialog-close]="true"
      type="button"
      color="{{ data.confirmButtonType === 'confirm' ? 'primary' : 'warn' }}"
    >
      {{ data.confirmButtonText }}
    </button>
  </mat-dialog-actions>
</div>
